import { motion } from "framer-motion";
import { WORK_PHOTOS } from "@/constants/site";
import { useLanguage } from "@/i18n/LanguageContext";

const images = [
  WORK_PHOTOS.bedroomSunflower,
  WORK_PHOTOS.bedroomStarry,
  WORK_PHOTOS.kitchen,
  WORK_PHOTOS.entrance,
  WORK_PHOTOS.balconySwing,
  WORK_PHOTOS.livingRoom,
  WORK_PHOTOS.bedroomGold,
  WORK_PHOTOS.poojaRoom,
  WORK_PHOTOS.officeStudy,
];

export const Portfolio = () => {
  const { t } = useLanguage();

  return (
    <section id="work" className="py-24 lg:py-32 bg-[#2A211D]" data-testid="portfolio-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-[#D4AF37] tracking-[0.4em] uppercase text-sm mb-4">{t.portfolio.eyebrow}</p>
          <h2 className="font-heading text-4xl sm:text-5xl text-[#FDFBF7] max-w-2xl" data-testid="portfolio-heading">
            {t.portfolio.heading}
          </h2>
          <p className="mt-6 text-[#B8A99A] max-w-xl text-sm md:text-base leading-relaxed">
            {t.portfolio.sub}
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {images.map((img, i) => (
            <motion.figure
              key={img}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="group relative overflow-hidden border border-[#D4AF37]/20"
              data-testid={`portfolio-item-${i + 1}`}
            >
              <img
                src={img}
                alt={t.portfolio.labels[i]}
                className="w-full h-80 object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#1A1412] to-transparent p-6">
                <span className="font-heading text-xl text-[#D4AF37]">{t.portfolio.labels[i]}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
